import React from "react"
import { Link } from "gatsby"
import Arrow from "../images/icon-arrow.svg"

const CaseCard = ({ post, currentPath }) => {
  const isTopPage = currentPath === "/restaurant/"
  const linkUrl = `cases${post.fields.slug}`
  const CaseLink =
    currentPath === "/restaurant/cases/"
      ? `.${post.fields.slug}`
      : `/cases${post.fields.slug}`

  // 画像のURL。プロジェクトの設定によってパスは異なる可能性があります。
  const imageUrl = post.frontmatter.thumbnail.childImageSharp.gatsbyImageData

  const CardContent = () => (
    <div className="case_card__wrapper">
      <div className="case_card__thumn_img">
        <img src={imageUrl.images.fallback.src} alt={post.frontmatter.title} />
      </div>
      <div className="case_card__bottom">
        <h2>{post.frontmatter.title}</h2>
        <p>{post.frontmatter.store}</p>
        <div className="case_card__detail">
          <div className="tags">
            <span> {post.frontmatter.genre}</span>
            <span> {post.frontmatter.deliveryMethod}</span>
            <span> {post.frontmatter.theme}</span>
          </div>
          <img className="case_card__arrow" src={Arrow} alt="矢印" />
        </div>
      </div>
    </div>
  )

  return (
    <div className="case_card">
      {isTopPage ? (
        <a href={linkUrl} className="case_card__link toppage">
          <CardContent />
        </a>
      ) : (
        <Link to={CaseLink} className="case_card__link casepage">
          <CardContent />
        </Link>
      )}
    </div>
  )
}

export default CaseCard
